module.exports = __webpack_public_path__ + "static/media/playstore.e6e9e6ef.png";